import React from 'react';
import { Link } from 'react-router-dom';
import Panel from '../../components/ui/Panel';

const FigmaPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Figma</h1>
      <p className="text-osrs-yellow mb-8">
        This repository does not publish a Figma library. The code package is the source of truth. Use the notes below if you redraw the components in a design tool.
      </p>

      <section id="getting-started" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Getting Started</h2>
        <Panel>
          <ol className="list-decimal list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Create colour styles from the tokens on the <Link className="text-osrs-gold" to="/foundations/colors">colours page</Link>.</li>
            <li>Turn off corner radius for windows, buttons, slots, and inputs.</li>
            <li>Draw a 2px border. Light on the top and left. Dark on the bottom and right.</li>
            <li>Use the RuneScape font that ships with styles.css, or a fallback sans.</li>
          </ol>
        </Panel>
      </section>

      <section id="components" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Components</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">Redraw these as components. Each one already exists in code.</p>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Button. Stone, yellow text. Secondary is darker. Danger keeps the stone and uses red text.</li>
            <li>Panel. Raised window. Optional title bar and red close mark.</li>
            <li>Input and checkbox. Inset. Yellow text. Yellow tick.</li>
            <li>Dialog. The panel, centred on a dimmed backdrop.</li>
            <li>Tooltip. Black fill, yellow title, white body.</li>
            <li>Scrollbar. Sixteen pixel track, arrow buttons, stone thumb.</li>
            <li>Progress. Inset track. Green, red, blue, or gold fill.</li>
            <li>Inventory slot. 40 by 36. White outline when selected. Stack count at the top left.</li>
          </ul>
        </Panel>
      </section>

      <section id="styles" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Styles</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Stone #3E3530, highlight #6B5840, shadow #1C1612.</li>
            <li>Chat stone #C4B48C.</li>
            <li>Interface text #F5E20D, sampled from yellow copy on the bank window.</li>
          </ul>
        </Panel>
      </section>

      <section id="templates" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Templates</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Build a screen from the pattern pages. Inventory is 4 by 7. Chat is a log, an input line, and channel tabs. There is no separate template file to download.
          </p>
        </Panel>
      </section>
    </div>
  );
};

export default FigmaPage;
